import App from "./app";

export default function Root(props) {
  return <App {...props} />;
}
